// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3atji","header":"ReportDetails_header__1iEsP","title":"ReportDetails_title__wGF9n","left":"ReportDetails_left__ZWhD5"};